/** How store credit is issued for Aptos returns; NONE leaves store credit to the merchant. */
export enum AptosStoreCreditMode {
  NONE = "none",
  CREDIT_VENDOR = "credit_vendor",
  APTOS_CREDIT = "aptos_credit",
}

const storeCreditModes: readonly string[] = Object.values(AptosStoreCreditMode);

export function isAptosStoreCreditMode(
  value: string | null | undefined,
): value is AptosStoreCreditMode {
  return typeof value === "string" && storeCreditModes.includes(value);
}
